module.exports = "/static/media/DancingChimes.378a4a8a.wav";